(function() {
  if (window.__ktProductCarouselDelegated) return;
  window.__ktProductCarouselDelegated = true;

  var carouselState = new WeakMap();
  var activeMouseDrag = null;

  function findWrapper(target) {
    return target && target.closest ? target.closest('.kt-product-carousel__wrapper') : null;
  }

  function updateDots(state) {
    state.dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === state.index);
    });
  }

  function setTrackPosition(state, pos, animate) {
    state.pos = pos;
    state.track.style.transition = animate ? 'transform 0.35s ease' : 'none';
    state.track.style.transform = 'translateX(-' + (pos * 100) + '%)';
  }

  /* ---- Setup perezoso: clona la primera/última slide para permitir bucle infinito ---- */
  function setupCarousel(wrapper) {
    var existing = carouselState.get(wrapper);
    if (existing) return existing;

    var track = wrapper.querySelector('.kt-product-carousel__track');
    if (!track) return null;

    var slides = Array.prototype.slice.call(track.children);
    var count = slides.length;
    if (count < 2) return null;

    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[count - 1].cloneNode(true);
    [firstClone, lastClone].forEach(function(clone) {
      clone.setAttribute('aria-hidden', 'true');
      if (clone.id) clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function(el) { el.removeAttribute('id'); });
      clone.querySelectorAll('script').forEach(function(el) { el.remove(); });
    });
    track.insertBefore(lastClone, track.firstChild);
    track.appendChild(firstClone);

    var state = {
      track: track,
      dots: Array.prototype.slice.call(wrapper.querySelectorAll('.kt-product-carousel__dot')),
      count: count,
      index: 0,
      pos: 1,
      startX: 0,
      startY: 0,
      diffX: 0,
      dragging: false,
      horizontal: null,
      didDrag: false
    };

    setTrackPosition(state, 1, false);
    void track.offsetHeight; /* fuerza reflow antes de reactivar la transición */

    /* Al llegar a un clon, salta sin transición a la slide real equivalente */
    track.addEventListener('transitionend', function(e) {
      if (e.propertyName !== 'transform') return;
      if (state.pos === 0) {
        setTrackPosition(state, state.count, false);
      } else if (state.pos === state.count + 1) {
        setTrackPosition(state, 1, false);
      }
    });

    carouselState.set(wrapper, state);
    return state;
  }

  function goToIndex(state, index) {
    if (index < 0) index = state.count - 1;
    if (index >= state.count) index = 0;
    state.index = index;
    setTrackPosition(state, index + 1, true);
    updateDots(state);
  }

  function step(state, dir) {
    state.index = (state.index + dir + state.count) % state.count;
    setTrackPosition(state, state.pos + dir, true);
    updateDots(state);
  }

  function endDrag(state) {
    if (!state.horizontal) return;
    if (Math.abs(state.diffX) > 40) {
      step(state, state.diffX < 0 ? 1 : -1);
    } else {
      setTrackPosition(state, state.pos, true);
    }
  }

  /* ---- Touch ---- */
  document.addEventListener('touchstart', function(e) {
    var wrapper = findWrapper(e.target);
    if (!wrapper) return;
    var state = setupCarousel(wrapper);
    if (!state) return;
    state.startX = e.touches[0].clientX;
    state.startY = e.touches[0].clientY;
    state.diffX = 0;
    state.dragging = true;
    state.horizontal = null;
    state.didDrag = false;
    state.track.style.transition = 'none';
  }, { passive: true });

  document.addEventListener('touchmove', function(e) {
    var wrapper = findWrapper(e.target);
    if (!wrapper) return;
    var state = carouselState.get(wrapper);
    if (!state || !state.dragging) return;

    var dx = e.touches[0].clientX - state.startX;
    var dy = e.touches[0].clientY - state.startY;

    if (state.horizontal === null) {
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
        state.horizontal = Math.abs(dx) > Math.abs(dy);
      } else {
        return;
      }
    }
    if (!state.horizontal) return;

    e.preventDefault();
    state.didDrag = true;
    state.diffX = dx;
    state.track.style.transform = 'translateX(calc(-' + (state.pos * 100) + '% + ' + dx + 'px))';
  }, { passive: false });

  document.addEventListener('touchend', function(e) {
    var wrapper = findWrapper(e.target);
    if (!wrapper) return;
    var state = carouselState.get(wrapper);
    if (!state || !state.dragging) return;
    state.dragging = false;
    endDrag(state);
  });

  /* ---- Mouse (escritorio) ---- */
  /* Evita que el navegador inicie el drag nativo de la imagen */
  document.addEventListener('dragstart', function(e) {
    if (findWrapper(e.target)) e.preventDefault();
  });

  document.addEventListener('mousedown', function(e) {
    if (e.button !== 0) return; /* solo botón izquierdo */
    var wrapper = findWrapper(e.target);
    if (!wrapper) return;
    var state = setupCarousel(wrapper);
    if (!state) return;
    activeMouseDrag = { wrapper: wrapper, state: state };
    state.startX = e.clientX;
    state.diffX = 0;
    state.didDrag = false;
    state.track.style.transition = 'none';
    var productImage = wrapper.closest('.kt-product-image');
    if (productImage) productImage.classList.add('is-dragging');
    e.preventDefault();
    /* Dentro de un css-slider (recomendados) el slider no debe arrastrar a la vez */
    if (wrapper.closest('css-slider')) e.stopPropagation();
  }, true);

  window.addEventListener('mousemove', function(e) {
    if (!activeMouseDrag) return;
    var state = activeMouseDrag.state;
    state.diffX = e.clientX - state.startX;
    if (Math.abs(state.diffX) > 5) state.didDrag = true;
    if (state.didDrag) {
      e.preventDefault();
      state.track.style.transform = 'translateX(calc(-' + (state.pos * 100) + '% + ' + state.diffX + 'px))';
    }
  });

  window.addEventListener('mouseup', function() {
    if (!activeMouseDrag) return;
    var wrapper = activeMouseDrag.wrapper;
    var state = activeMouseDrag.state;
    var productImage = wrapper.closest('.kt-product-image');
    if (productImage) {
      /* mantener la clase un tick más para que el "click" sintético posterior
         sobre el quick-buy se cancele si fue un arrastre */
      setTimeout(function() { productImage.classList.remove('is-dragging'); }, 0);
    }
    activeMouseDrag = null;
    if (!state.didDrag) return;
    state.horizontal = true;
    endDrag(state);
  });

  /* ---- Dots y click sobre el wrapper → ir al producto (si no fue drag) ---- */
  document.addEventListener('click', function(e) {
    var dot = e.target.closest ? e.target.closest('.kt-product-carousel__dot') : null;
    if (dot) {
      var dotWrapper = findWrapper(dot);
      var dotState = dotWrapper && setupCarousel(dotWrapper);
      if (dotState) {
        e.preventDefault();
        e.stopPropagation();
        goToIndex(dotState, parseInt(dot.dataset.index, 10));
      }
      return;
    }

    var wrapper = findWrapper(e.target);
    if (!wrapper) return;
    var state = carouselState.get(wrapper);
    if (!state) return;

    if (state.didDrag) {
      state.didDrag = false;
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    var productImage = wrapper.closest('.kt-product-image');
    var productLink = productImage ? productImage.querySelector('.kt-product-image__link') : null;
    var productUrl = productLink ? productLink.getAttribute('href') : null;
    if (productUrl) window.location.href = productUrl;
  });
})();
